export default "__VITE_ASSET__qzUjGIq1__"